import React, { FunctionComponent } from 'react';
import BookedRoomsTable from './BookedRoomsTable';

const BookedRoomsTab: FunctionComponent = () => (
    <BookedRoomsTable rooms={[]} />
);

export default BookedRoomsTab;
